<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 11.75a3.75 3.75 0 1 0 7.5 0 3.75 3.75 0 0 0-7.5 0ZM16.87 20.051l-4.59-4.59M15.46 12.28l4.59 4.589M3.45 16.869l4.59-4.59M11.22 15.462l-4.59 4.589M6.63 3.45l4.59 4.589M8.04 11.221l-4.59-4.59M20.05 6.631l-4.59 4.59M12.28 8.039l4.59-4.589"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2 11.75a9.75 9.75 0 1 0 19.5 0 9.75 9.75 0 0 0-19.5 0Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
